var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.barText)?_c('snack-bar',{staticClass:"cashflow-state-bar",attrs:{"text":_vm.barText,"variant":_vm.barVariant},scopedSlots:_vm._u([{key:"secondary",fn:function(){return [(_vm.lastUpdatedText)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.lastUpdatedText))]):_vm._e()]},proxy:true}],null,false,3413144898)}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589fe407","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/CashflowStateBar.vue
// module id = null
// module chunks = 